import { render, staticRenderFns } from "./FloatImg.vue?vue&type=template&id=563c7012&scoped=true&"
import script from "./FloatImg.vue?vue&type=script&lang=js&"
export * from "./FloatImg.vue?vue&type=script&lang=js&"
import style0 from "./FloatImg.vue?vue&type=style&index=0&id=563c7012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c7012",
  null
  
)

export default component.exports